module.exports = __webpack_public_path__ + "static/media/history.de31ca89.svg";